import styles from "./Angebote.module.css";
import AngeboteKarte from "./AngeboteKarte/AngeboteKarte.jsx";
import AngeboteKarteIT from "./AngeboteKarte/AngeboteKarteIT.jsx";
import AngeboteKarteGR from "./AngeboteKarte/AngeboteKarteGR.jsx";

function Angebote({ title, body }) {
  return (
    <>
      <div className={styles.cardsWrapper}>
        <div className={styles.cardsContainer}>
         <AngeboteKarteIT
            title="Italien"
            price="14,90€"
            body="Antipasti, Pasta und hausgemachte Dolci – La Dolce Vita auf eurem Event."
            />
            
                   
        

          <AngeboteKarte
            title="Mexiko"
            price="14,90€"
            body="Feurige Tacos, frische Guacamole, Salsas und Cheesecake – ein authentisches Geschmackserlebnis."
            />
          
          
          <AngeboteKarteGR
            title="Griechenland"
            price="14,90€"
            body="Griechische Spezialitäten wie Moussaka und mehr – ein Fest der Aromen."
            />
        </div>
      </div>
      <a href="/kontakt" className={styles.contactLink}>
        Kontakt aufnehmen
      </a>
    </>
  );
}

export default Angebote;
